import React from "react";

export default function AdminSettingsProfilePage() {
  return <div>AdminSettingsProfilePage</div>;
}
